import { Options, Vue } from 'vue-class-component';
import { TrustAPI } from '@/shared/modules/trust-api';
import { Inject } from 'vue-property-decorator';
import { AppInsights } from '@/trust-admin-app/appInsights';
import { EventEmitter } from 'events';
import store from '@/trust-admin-app/store';
import LoadingIndicator from '@/shared/components/loading-indicator/index.vue';
import ErrorIndicator from '@/shared/components/error-indicator/index.vue';
import { orderBy } from 'lodash';
import AddEeModal from './add-ee-modal/index.vue';
import { RouteN } from '@/trust-admin-app/constants/router-name';
@Options({
  components: {
    LoadingIndicator,
    ErrorIndicator,
    AddEeModal,
  }
})
export default class TrustDataExternalExaminer extends Vue {
  @Inject({ from: 'apiService', default: new TrustAPI() })
  private apiService!: TrustAPI;

  private ai = new AppInsights;

  get eventCtrl(): EventEmitter {
    return store.getters.getEventController;
  }

  private firstLoad = true;
  private loadingContent = false;
  private errorLoadingContent = false;
  private showAddEEModal = false;

  private eeList: any = [];
  private eeListDisplay: any = [];
  private searchText = '';
  private sortMethod = 'desc';
  private activeSortHeader = 2;

  private tableHeadings = [
    { text: 'LawID', value: 'lawId', sortable: false },
    { text: 'Email', value: 'email', sortable: false },
    { text: 'Last name', value: 'lastName', sortable: false },
    { text: 'First name', value: 'firstName', sortable: false },
    { text: 'Status', value: 'inactive', sortable: true, sortMethod: 'asc', activeSort: true },
    { text: 'Action', value: 'action', sortable: false },
  ];

  mounted() {
    //
  }

  private searchEE() {
    this.getEE();
  }

  private getEE() {
    this.firstLoad = false;
    this.loadingContent = true;
    this.errorLoadingContent = false;
    this.apiService.ExternalExaminerApi?.apiV2ExternalExaminerAdminGetExternalExaminersPost({ keyword: this.searchText })
      .then((res: any) => {
        this.eeList = res.data.data;
        this.sortTableColumn(4, true);
      })
      .catch((err: any) => {
        this.errorLoadingContent = true;
        this.eventCtrl.emit('show-snackbar', 'error', 'Unable to load External Examiner data');
        this.ai.trackException('Error getting External Examiner data: ' + err);
      }).finally(() => {
        this.loadingContent = false;
      });

  }

  private sortTableColumn(index: number, sortable: boolean) {
    if (sortable) {
      if (this.tableHeadings[index].sortable) {
        this.activeSortHeader = index;
        this.sortMethod = this.sortMethod === 'desc' ? 'asc' : 'desc';
        this.tableHeadings[index].sortMethod = this.sortMethod;
        if (this.eeList.length > 0) {
          // const nameSorter = index == 0 ? (c: any) => c.name.toLowerCase() : [this.tableHeadings[index].value, (c: any) => c.name.toLowerCase()];
          const orderByResults = orderBy(
            this.eeList,
            ['inactive', 'lawId'],
            [this.sortMethod as any, 'asc']
          );
          this.eeListDisplay = orderByResults;
        }
      }
    }
  }

  private gotoExternalExaminerDashboard(id: number) {
    this.$router.push({ name: RouteN.TA.ExternalExaminer.n, query: { eeId: id } });
  }

}

